/**
 * Created by minimus on 22.07.2016.
 */

let ads;

(function ($) {
  const asOptions = samProOptions.sliderOptions;
  const options = samProOptions;
  const doStats = (options.doStats === '1');
  const jsStats = (1 === parseInt(options.jsStats, 10));
  const nonce = options.samProNonce;
  //const mailer = (options.mailer === '1');
  const load = (options.load === '1');
  const path = options.ajaxUrl;
  const data = options.clauses;
  //const rotate = (1 === parseInt(options.rotate, 10));
  //const rotateInterval = parseInt(options.rotateInterval, 10) * 1000;
  //const rotateMode = parseInt(asOptions.rotateMode, 10);
  const hits = [];


  function samProLoadAds(ads) {
    $.post(path, {
      action: 'sp_as_load_slider_ads',
      ads: ads,
      data: data,
      sam_pro_nonce: nonce
    }).done((response) => {
      if (response.success) {
        const aAds = [];
        const aHits = [];
        $.each(response.data, (i, ad) => {
          $('#' + ad.eid).replaceWith(ad.ad);
          if (ad.count === 1) {
            aHits.push({pid: ad.pid, aid: ad.aid});
            aAds.push({pid: ad.pid, aid: ad.aid, cid: ad.cid});
          }
          else if (ad.count > 1) {
            for (let j = 0; j < ad.count; j++) {
              aHits.push({pid: ad.pid, aid: ad.aid[j]});
              aAds.push({pid: ad.pid, aid: ad.aid[j], cid: ad.cid[j]});
            }
          }
        });

        $('div.bjqs-sas').each((i, el) => {
          const width = $(el).data('width');
          const height = $(el).data('height');
          if ($(el).parent().hasClass('sp-fixed-body')) {
            if (window.screen.width < width + 53) {
              const
                rate = width / height,
                rWidth = window.screen.width - 53,
                rHeight = rWidth / rate;
              $(el).parent().css({width: rWidth, height: rHeight});
            }
            else $(el).parent().css({width, height});
          }
          else {
            if (window.screen.width < width + 20) {
              const
                rate = width / height,
                rWidth = window.screen.width - 20,
                rHeight = rWidth / rate;
              $(el).css({width: rWidth, height: rHeight});
            }
            else $(el).css({width, height});
          }
          $(el).bjqs({
            width: width,
            height: height,
            responsive: true,
            animtype: asOptions.animation,
            animduration: asOptions.speed,
            animspeed: asOptions.delay,
            showcontrols: false,
            showmarkers: false
          });
        });

        $.each(aAds, (i, el) => {
          if (doStats) {
            const cnt = $('#' + el.cid);
            cnt.find('a').on('click', () => {
              $.post(path, {
                action: 'sp_as_sam_click',
                aid: el.aid,
                pid: el.pid,
                sam_pro_nonce: nonce
              });
            });
            cnt.find('iframe').iframeTracker({
              blurCallback: function () {
                $.post(path, {
                  action: 'sp_as_sam_click',
                  aid: el.aid,
                  pid: el.pid,
                  sam_pro_nonce: nonce
                });
              }
            });
          }
        });

        if (doStats && jsStats && (aHits.length > 0)) {
          $.post(path, {
            action: 'sp_as_sam_hits',
            hits: aHits,
            sam_pro_nonce: nonce
          });
        }
      }
    });
  }

  $(document).ready(function () {
    if (load) {
      // Ads loaded by PHP
      if (doStats) {
        $(`div.${options.place}, span.${options.place}`).each((i, el) => {
          const ids = el.id.split('_');
          const aid = parseInt(ids[1], 10);
          const pid = parseInt(ids[2], 10);
          hits.push({aid, pid});
          $(el).find('a').on('click', () => {
            $.post(path, {action: 'sp_as_sam_click', aid, pid, sam_pro_nonce: nonce});
          });
          $(el).find('iframe').iframeTracker({
            blurCallback: function () {
              $.post(path, {action: 'sp_as_sam_click', aid, pid, sam_pro_nonce: nonce});
            }
          });
        });

        if (jsStats && hits.length > 0) {
          $.post(path, {action: 'sp_as_sam_hits', hits, sam_pro_nonce: nonce});
        }
      }

      // Loading Ads
      ads = [];
      $(`div.${options.ad}, span.${options.ad}`).each((i, el) => {
        let codes = $(el).data('spc');
        if ('undefined' === typeof codes) codes = 0;
        const ids = el.id.split('_');
        const id = ids[1];
        const pid = ids[2];

        ads.push({pid, aid: id, codes, eid: el.id});
      });

      if (ads.length > 0) {
        samProLoadAds(ads);
      }
    }
  })
})(jQuery);